import React from 'react'

export const HeroHeader = () => {
    return (
        <header>
            {/* Empty header for spacing - navigation is in layout */}
        </header>
    )
}
